import {useContextSelector} from 'use-context-selector'
import {ExplorerContext} from '../context/ExplorerContext'

export function useLayer() {
  const layers = useContextSelector(ExplorerContext, (mapa) => mapa['layers'])
  const onAddLayer = useContextSelector(ExplorerContext, (mapa) => mapa['onAddLayer'])
  const onUpdateLayer = useContextSelector(ExplorerContext, (mapa) => mapa['onUpdateLayer'])
  return {layers, onAddLayer, onUpdateLayer}
}
